// extracted by mini-css-extract-plugin
module.exports = {"landingHighlight":"LandingHighlight_landingHighlight__6DyfA"};